import { render } from "./logo-negative.vue?vue&type=template&id=129c29f0"
import script from "./logo-negative.vue?vue&type=script&lang=js"
export * from "./logo-negative.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__